import DeleteWidgetCriteria from 'use-case/widgets/delete/deleteWidgetCriteria';
import { getNoContentApiClient } from 'adapter/out/client/apiClient';

export default getNoContentApiClient(
    (criteria: DeleteWidgetCriteria) => `dashboards/dashboards/${criteria.dashboardId}/widgets/${criteria.widgetId}`,
    () => ({
        method: 'DELETE',
        body: undefined,
        headers: { 'Content-Type': 'application/json' },
    })
);
